// import { children } from "react";
import Container from "../Container";
import Foot from "../Footer/Foot";
import Nav from "../Navbar/Nav";

function Layout(props){
    return(
        <div>
            <Nav />
            {/* contaiment  lalu bungkus dengan main tag signmantic */}
            <main>
                <Container>
                    {props.children}
                </Container>
            </main>
            
            <Foot />
        </div>
       
    )
}

export default Layout;